import * as React from 'react';

export interface ScreenSizeShape {
    width: number;
    height: number;
}

/**
 * Provides information about the size of the browser's content viewport.
 * Values change whenever the browser is resized, so should be used for responsive design.
 */
export const useWindowSize = (): ScreenSizeShape => {
    const [windowSize, setWindowSize] = React.useState<ScreenSizeShape>({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    React.useEffect(() => {
        function onResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return windowSize;
};
